import { render, staticRenderFns } from "./CancelAccount.vue?vue&type=template&id=52b16f1f"
import script from "./CancelAccount.vue?vue&type=script&lang=js"
export * from "./CancelAccount.vue?vue&type=script&lang=js"
import style0 from "./CancelAccount.vue?vue&type=style&index=0&id=52b16f1f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports